import { render, staticRenderFns } from "./FeeWaiver.vue?vue&type=template&id=540f4d31"
import script from "./FeeWaiver.vue?vue&type=script&lang=js"
export * from "./FeeWaiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports